module.exports = __webpack_public_path__ + "img/5f_r_musashi@2x.0e3ac18d.png";